import Vue from 'vue'
import Vuex from 'vuex'
import * as mutations from './mutations'
import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'
var ls = new SecureLS({ isCompression: false })

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        usuario: null,
        updatePassword: true,
        permissoes: []
    },
    mutations,
    plugins: [
        createPersistedState({
            storage: {
                getItem: (key) => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: (key) => ls.remove(key)
            }
        })
    ],
})

